var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbUpAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19451_724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.12 2.06095L7.58 7.60095C7.21 7.97095 7 8.48095 7 9.01095L7 19.0009C7 20.1009 7.9 21.0009 9 21.0009L18 21.0009C18.8 21.0009 19.52 20.5209 19.84 19.7909L23.1 12.1809C23.94 10.2009 22.49 8.00095 20.34 8.00095L14.69 8.00095L15.64 3.42095C15.74 2.92095 15.59 2.41095 15.23 2.05095C14.64 1.47095 13.7 1.47095 13.12 2.06095ZM3 21.0009C4.1 21.0009 5 20.1009 5 19.0009L5 11.0009C5 9.90094 4.1 9.00095 3 9.00095C1.9 9.00095 1 9.90094 1 11.0009L1 19.0009C1 20.1009 1.9 21.0009 3 21.0009Z",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19451_724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpAlt);
export default __webpack_public_path__ + "static/media/thumb_up_alt.2c7e9991aa8cdcd126252404b6610b36.svg";
export { ForwardRef as ReactComponent };